<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="60%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="图片" prop="image">
          <el-upload
            :multiple="false"
            :limit="1"
            :class="{ disabled: form.image.length > 0 }"
            :action="QNUploadURL"
            :data="uploadToken"
            list-type="picture-card"
            :file-list="form.image"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <span>建议尺寸: 750px * 380px</span>
        </el-form-item>
        <el-form-item label="跳转页面地址" prop="url">
          <el-input v-model.trim="form.url" placeholder="请输入跳转页面地址" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createCarousel, updateCarousel } from '@/api/display'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
export default {
  name: 'ShopCarouselEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      QNUploadURL,
      uploadToken: '',
      form: {
        carouselId: '',
        image: [],
        url: '',
        position: 'PRODUCT',
        order: 1,
      },
      rules: {
        image: [
          {
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error('请上传图片'))
              } else {
                callback()
              }
            },
          },
        ],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    async showEdit(row) {
      if (row) {
        this.title = '修改轮播图'
        this.form = Object.assign(this.form, row.basic)
        this.form.carouselId = row.carouselId
      } else {
        this.title = '新增轮播图'
      }
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
    },
    // 图片
    image_remove(file, fileList) {
      this.form.image = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    image_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.image.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const carouselId = this.form.carouselId
          this.$baseConfirm(
            `你确定要${carouselId ? '修改' : '新增'}轮播图吗`,
            null,
            async () => {
              carouselId
                ? await updateCarousel(this.form)
                : await createCarousel(this.form)
              this.$baseMessage(
                `${carouselId ? '修改' : '新增'}轮播图成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss">
.disabled .el-upload--picture-card {
  display: none;
}
</style>
